import { createContext, useContext, useState } from "react";

interface GameContexteProps {
  questionNumber: number;
  totalPoints: number;
  totalQuestions: number;
  setTotalQuestions: (questions: number) => void;
  incrementPoints: (points: number) => void;
  nextQuestion: () => void;
  resetPoints: () => void;
  resetQuestionNumber: () => void;
  gameFinished: boolean;
  setGameFinished: (finished: boolean) => void;
  totalPlayers: number;
  setTotalPlayers: (players: number) => void;
  equipesIcons: string[];
  setEquipesIcons: (icons: string[]) => void;
  equipesNoms: string[];
  setEquipesNoms: (noms: string[]) => void;
  equipesPoints: number[];
  setEquipesPoints: (points: number[]) => void;
  activePlayer: number;
  setActivePlayer: (player: number) => void;
  resetEquipesPoints: () => void;
  winner: number;
  setWinner: (winner: number) => void;
}

const GameContext = createContext<GameContexteProps | undefined>(undefined);

export const useGame = () => {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error("useGame must be used within a GameProvider");
  }
  return context;
};

export const GameProvider = ({ children }: { children: React.ReactNode }) => {
  const [questionNumber, setQuestionNumber] = useState(1);
  const [totalPoints, setTotalPoints] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(1);
  const [gameFinished, setGameFinished] = useState(false);
  const [totalPlayers, setTotalPlayers] = useState(1);
  const [equipesIcons, setEquipesIcons] = useState<string[]>([
    "",
    "",
    "",
    "",
    "",
  ]);
  const [equipesNoms, setEquipesNoms] = useState<string[]>([
    "",
    "",
    "",
    "",
    "",
  ]);
  const [equipesPoints, setEquipesPoints] = useState<number[]>([0, 0, 0, 0, 0]);

  const [activePlayer, setActivePlayer] = useState(0);
  const [winner, setWinner] = useState(0);

  const incrementPoints = (points: number) => {
    setTotalPoints((prevPoints) => prevPoints + points);
  };

  const nextQuestion = () => {
    setQuestionNumber((prevNumber) => prevNumber + 1);
  };

  const resetPoints = () => setTotalPoints(0);
  const resetQuestionNumber = () => {
    setQuestionNumber(1);
  };

  const resetEquipesPoints = () => {
    const zeroPoints = new Array(equipesPoints.length).fill(0);
    setEquipesPoints(zeroPoints);
  };

  return (
    <GameContext.Provider
      value={{
        questionNumber,
        totalPoints,
        totalQuestions,
        setTotalQuestions,
        incrementPoints,
        nextQuestion,
        resetPoints,
        resetQuestionNumber,
        gameFinished,
        setGameFinished,
        totalPlayers,
        setTotalPlayers,
        equipesIcons,
        setEquipesIcons,
        equipesNoms,
        setEquipesNoms,
        equipesPoints,
        setEquipesPoints,
        activePlayer,
        setActivePlayer,
        resetEquipesPoints,
        winner,
        setWinner,
      }}
    >
      {children}
    </GameContext.Provider>
  );
};
